<template>
  <div class="site-footer">
    <background-tilt/>
    <nav>
      <ul>
        <li><a href="https://www.enercity.de/kontakt" target="_blank" draggable="false" ondragstart="return false;">Kontakt</a></li>
        <li><a href="https://www.enercity.de/datenschutz" target="_blank" draggable="false" ondragstart="return false;">Datenschutz</a></li>
        <li><a href="https://www.enercity.de/impressum" target="_blank" draggable="false" ondragstart="return false;">Impressum</a></li>
        <li><a href="#" @click.prevent="toggleCredits">Credits</a></li>
      </ul>
    </nav>
    <social-share parent="site" />
    <p class="copy">&copy; 2021 enercity AG</p>
  </div>
  <teleport to="body">
    <transition name="fade">
      <div class="credits" v-if="creditsOpen">
        <div class="window">
          <h2>Credits</h2>
          <div class="cols">
            <p><strong>Fotos:</strong> Getty Images (31), Shutterstock (5), Offset (1), Stocksy (2), Westend61/ Peter Scholl, enercity AG (15), PR (5), Benne Ochs (3), Verena Prüning</p>
            <p><strong>Videos:</strong> Getty Images</p> <br>
            <p><strong>Illustrationen:</strong> Guten Tag-Hamburg (Infografik), The Noun Project (5)</p>
            <p><strong>Texte:</strong> Claus Hornung (Verlässlichkeit); Jens Lehmann (Innovation + Nachhaltigkeit); Florian Sievers (Kundenorientierung)</p>
          </div>
          <button class="closer" @click.prevent="toggleCredits" />
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import SocialShare from "@/elements/SocialShare";
import BackgroundTilt from "@/elements/BackgroundTilt";
export default {
  name: "SiteFooter",
  components: {BackgroundTilt, SocialShare},
  data() {
    return {
      creditsOpen: false
    }
  },
  methods: {
    toggleCredits() {
      this.creditsOpen = !this.creditsOpen;
    }
  }
}
</script>

<style scoped>
ul {
  position: relative;
  list-style: none;
  margin: 0 -5px;
  min-width: 200px;
}
a {
  color: #102D61;
  text-decoration: none;
  display: inline-block;
  padding: 3px 5px;
}
p {
  position: relative;
  color: #102D61;
  margin-top: auto;
}
.credits {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 101;
  background-color: rgba(16, 45, 97, 0.8);
}
.credits h2 {
  margin-top: 5px;
  margin-bottom: 20px;
}
.credits p {
  margin-top: 0;
}
.window {
  position: relative;
  width: 92%;
  max-width: 580px;
  padding: 36px 40px 32px;
  background-color: #fff;
  box-shadow: 0 10px 50px -15px rgba(0, 0, 0, 0.5);
  font-weight: 400;
  font-size: 14px;
  transition: transform 0.4s ease;
  transform: translate3d(0, 0, 0) scale(1);
}
.cols {
  column-count: 2;
  column-gap: 30px;
}
.window strong {
  display: block;
}
.closer {
  position: absolute;
  top: 0;
  right: 0;
  width: 50px;
  height: 50px;
  background-color: transparent;
  border: 0;
  cursor: pointer;
}
.closer:before, .closer:after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -1px -12px;
  width: 24px;
  height: 2px;
  background-color: #102D61;
  transform: rotate(45deg);
}
.closer:after {
  transform: rotate(-45deg);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-from .window,
.fade-leave-to .window {
  transform: translate3d(0, 0, 0) scale(0.8);
}
@media(min-width: 1000px) {
  .site-footer {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    z-index: 1;
    text-align: right;
    padding: 180px 70px 50px 11vh;
    height: 100%;
    overflow: hidden;
  }
  .background-tilt {
    left: 11vh;
  }
  nav {
    position: relative;
  }
  .social-share {
    position: relative;
  }
}
@media(max-width: 999px) {
  .site-footer {
    background-color: #fff;
    padding: 34px;
  }
  .site-footer:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 25vh;
    width: 120vw;
    background-color: #fff;
    transform-origin: 0 0;
    transform: rotate(-8deg);
  }
  .site-footer > * {
    position: relative;
  }
  .background-tilt {
    display: none;
  }
  p {
    margin: 30px 0 20px;
  }
  ul {
    padding: 10px 0 30px;
  }
  li {
    display: inline-block;
  }
}
@media(max-width: 567px) {
  .site-footer {
    padding: 20px;
  }
  ul {
    padding-bottom: 15px;
  }
  .copy {
    margin-top: 15px;
  }
  .window {
    padding: 24px;
  }
  .cols {
    column-count: 1;
  }
  .cols br {
    display: none;
  }
}
</style>